import { useEffect, useMemo } from "react";
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { roles } from "../../util/config/roles";
import { AppDispatch, AppState } from "../../store/configureStore";
import { getCompanyLogo } from "../../store/slices/companies";
import "./CompanyLogo.css";
import React from "react";


// Define props interface
interface CompanyLogoProps {
    className?: string;
}

const CompanyLogo: React.FC<CompanyLogoProps> = ({ className = "" }) => {

    const { t } = useTranslation("common");
    const dispatch = useDispatch<AppDispatch>();
    const { isSuperAdmin } = roles();
    const isLoggedIn = useSelector((state: AppState) => state.users.auth.isLoggedIn);

    const { logo } = useSelector((state: AppState) => state.entities.companies);

    useEffect(() => {
        if (!isLoggedIn || isSuperAdmin) return;
        dispatch(getCompanyLogo());

    }, [isSuperAdmin, dispatch]);


    // Memoize profile picture to avoid unnecessary function calls
    const companyLogo = useMemo(() =>
        logo,
        [logo]
    );

    return (
        <NavLink className={`s_logo s_nav__item s_nav_item_title ${className}`} to="/">
            {companyLogo ? (
                <img src={companyLogo} alt={t("common:document.title")} loading="lazy" />
            ) : (<>
                    <img className="desktop-logo hide-mobile" src="./company-logo.svg" alt={t("common:document.title")} loading="lazy" />
                    <img className="mobile-logo show-mobile-block" src="./company-logo-badge.svg" alt={t("common:document.title")} loading="lazy" />
            </>
            )}
        </NavLink>
    );
};

// Wrap with React.memo for performance
export default React.memo(CompanyLogo);